import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { AxiosResponseConverter } from '@src/documents/AxiosResponseConverter';
import { ConditionSheets } from '@src/permits/completePermit/fields/ConditionSheets';

export const ConditionsSheetsClient = {
  download: async (id: string): Promise<{ blob: Blob; filename: string }> => {
    const response = await AuthenticatedClient.get(`/conditionsSheets/${id}`, {
      responseType: 'blob',
    });
    const contentDisposition = response.headers['content-disposition'] as
      | string
      | undefined;
    const fileNameRegexp = /filename="(.*)"/;
    const matches = contentDisposition
      ? contentDisposition.match(fileNameRegexp)
      : null;
    const filename = matches ? matches[1] : 'downloaded-file';
    const blob = AxiosResponseConverter.toBlob(response);

    return { blob, filename };
  },
  list: async (): Promise<ConditionSheets> => {
    const response = await AuthenticatedClient.get(`/conditionsSheets`);

    return new ConditionSheets(response.data);
  },
};
